import { Button } from 'src/components/ui/button';
import React, { useEffect } from 'react';
import { Controller, useFieldArray, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { object } from 'yup';
import { arrayOfCtaScheme } from 'src/utils/validation-schemes';
import Input from 'src/components/Input/Input';

const INITIAL_STATE = {
  pf_cta_value: '',
  pf_cta_condition: '',
};

export const SalesRoleStep3 = ({ data, onPrev, onSubmit, titleDescription, onCancel }) => {
  useEffect(() => {
    if (data) {
      data.forEach((item, index) => {
        setValue(`pf_cta.${index}.pf_cta_value`, item.pf_cta_value);
        setValue(`pf_cta.${index}.pf_cta_condition`, item.pf_cta_condition);
      });
    }
  }, [data]);

  const {
    control,
    handleSubmit,
    formState: { isDirty, isValid, errors },
    setValue,
  } = useForm({
    defaultValues: {
      pf_cta: data || [],
    },
    resolver: yupResolver(
      object({
        pf_cta: arrayOfCtaScheme({
          required: true,
        }),
      }),
    ),
  });
  const { fields, append, remove } = useFieldArray({
    control,
    name: 'pf_cta',
  });

  const submit = (data) => {
    onSubmit(data.pf_cta);
  };

  const addNewCta = () => {
    append({ ...INITIAL_STATE });
  };

  const removeCta = (index) => {
    remove(index);
  };

  useEffect(() => {
    if (!fields.length) {
      append({ ...INITIAL_STATE });
    }
  }, []);

  return (
    <form
      id="sales-role-step3-form"
      onSubmit={(e) => {
        e.stopPropagation();

        return handleSubmit(submit)(e);
      }}
    >
      <div>
        <p className={'text-ebony_opacity_50 text-sm font-medium'}>
          {titleDescription ||
            'Designed to engage potential customers, highlight product benefits, and drive conversions.'}
        </p>
      </div>
      <div className={'flex flex-col gap-2.5'}>
        <div>
          <p className={'mt-5 text-ebony_opacity_80 font-semibold text-base'}>CTAs</p>
        </div>
        <div className={'flex flex-col gap-5'}>
          {fields.map((cta, index) => {
            return (
              <div
                className={'border-l border-[#a498ff80] pl-2.5 gap-5 relative'}
                key={`cta-${index}`}
              >
                {Boolean(index) && (
                  <div
                    className={'absolute right-2 top-1 cursor-pointer'}
                    onClick={() => removeCta(index)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="10"
                      height="9"
                      viewBox="0 0 10 9"
                      fill="none"
                    >
                      <path d="M1 0.5L9 8.5M9 0.5L1 8.5" stroke="#E50505" strokeLinecap="round" />
                    </svg>
                  </div>
                )}
                <div>
                  <Controller
                    control={control}
                    name={`pf_cta.${index}.pf_cta_value`}
                    render={({ field: { onChange, value }, fieldState: { error } }) => (
                      <div className={'flex flex-col w-full'}>
                        <Input
                          autoFocus={!index && true}
                          className={'!py-2.5'}
                          type={'text'}
                          placeholder={'Ready to kick off a free trial?'}
                          label={`CTA #${index + 1}`}
                          invalidMessage={error?.message}
                          isValid={!error?.message}
                          value={value}
                          onChange={onChange}
                        />
                      </div>
                    )}
                  />
                </div>
                <div>
                  <Controller
                    control={control}
                    name={`pf_cta.${index}.pf_cta_condition`}
                    render={({ field: { onChange, value }, fieldState: { error } }) => (
                      <div className={'flex flex-col w-full'}>
                        <Input
                          className={'!py-2.5'}
                          type={'text'}
                          placeholder={'When you notice a purchase intent.'}
                          textareaRows={2}
                          label={'Condition'}
                          invalidMessage={error?.message}
                          isValid={!error?.message}
                          value={value}
                          onChange={onChange}
                        />
                      </div>
                    )}
                  />
                </div>
              </div>
            );
          })}
          <div>
            <span
              onClick={addNewCta}
              className={'text-[#7A6BE5] text-xs font-medium cursor-pointer hover:underline'}
            >
              Add CTA +
            </span>
          </div>
        </div>
      </div>
      <div className="flex justify-center mt-5">
        <div className="flex gap-2.5">
          <Button variant="outline" type="button" className="min-w-24" onClick={onCancel}>
            Cancel
          </Button>
          <Button
            variant="outline-light"
            type="button"
            className="min-w-24 flex flex-row gap-[5px]"
            onClick={onPrev}
          >
            <span>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="9"
                height="10"
                viewBox="0 0 9 10"
                fill="none"
              >
                <path
                  d="M9 4.4375L2.15438 4.4375L5.29875 1.29312L4.5 0.499998L0 5L4.5 9.5L5.29313 8.70687L2.15438 5.5625L9 5.5625V4.4375Z"
                  fill="#05050D"
                />
              </svg>
            </span>
            <span>Prev</span>
          </Button>
          <Button
            disabled={!isValid}
            form={'sales-role-step3-form'}
            className="min-w-24 flex flex-row gap-[5px]"
          >
            <span>Save</span>
          </Button>
        </div>
      </div>
    </form>
  );
};
